import axios from 'axios'
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  ADD_USER_FAIL,
  ADD_USER_REQUEST,
  ADD_USER_RESET,
  ADD_USER_SUCCESS,
  GET_ROLE_FAIL,
  GET_ROLE_REQUEST,
  GET_ROLE_RESET,
  GET_ROLE_SUCCESS,
  GET_USERS_FAIL,
  GET_USERS_REQUEST,
  GET_USERS_RESET,
  GET_USERS_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_LOGOUT_REQUEST,
  USER_LOGOUT_SUCCESS,
  USER_LOGOUT_FAIL,
  GET_USER_BY_ID_FAIL,
  GET_USER_BY_ID_REQUEST,
  GET_USER_BY_ID_RESET,
  GET_USER_BY_ID_SUCCESS,
  ADD_CUSTOMER_TO_USER_FAIL,
  ADD_CUSTOMER_TO_USER_REQUEST,
  ADD_CUSTOMER_TO_USER_RESET,
  ADD_CUSTOMER_TO_USER_SUCCESS,
  REMOVE_CUSTOMER_FROM_USER_FAIL,
  REMOVE_CUSTOMER_FROM_USER_REQUEST,
  REMOVE_CUSTOMER_FROM_USER_RESET,
  REMOVE_CUSTOMER_FROM_USER_SUCCESS,
  RESET_DEVICE_ID_FAIL,
  RESET_DEVICE_ID_REQUEST,
  RESET_DEVICE_ID_RESET,
  RESET_DEVICE_ID_SUCCESS,
  RESET_PASSWORD_FAIL,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_RESET,
  RESET_PASSWORD_SUCCESS,
  UPDATE_USER_FAIL,
  UPDATE_USER_REQUEST,
  UPDATE_USER_RESET,
  UPDATE_USER_SUCCESS,
  FETCH_ATTENDANCE_FAIL,
  FETCH_ATTENDANCE_REQUEST,
  FETCH_ATTENDANCE_RESET,
  FETCH_ATTENDANCE_SUCCESS,
  RESIGN_USER_FAIL,
  RESIGN_USER_REQUEST,
  RESIGN_USER_RESET,
  RESIGN_USER_SUCCESS,
  FORCE_LOGOUT_USER_FAIL,
  FORCE_LOGOUT_USER_REQUEST,
  FORCE_LOGOUT_USER_RESET,
  FORCE_LOGOUT_USER_SUCCESS,
  FORCE_LOGOUT_MULTIPLE_FAIL,
  FORCE_LOGOUT_MULTIPLE_REQUEST,
  FORCE_LOGOUT_MULTIPLE_RESET,
  FORCE_LOGOUT_MULTIPLE_SUCCESS,
  CHECK_USER_REQUEST,
  CHECK_USER_SUCCESS,
  CHECK_USER_FAIL,
  SEND_OTP_REQUEST,
  SEND_OTP_SUCCESS,
  SEND_OTP_FAIL,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAIL,
  GET_AFFILIATE_STATS_REQUEST,
  GET_AFFILIATE_STATS_SUCCESS,
  GET_AFFILIATE_STATS_FAIL,
  GET_AFFILIATE_REFERRALS_REQUEST,
  GET_AFFILIATE_REFERRALS_SUCCESS,
  GET_AFFILIATE_REFERRALS_FAIL,
  GET_AFFILIATE_EARNINGS_REQUEST,
  GET_AFFILIATE_EARNINGS_SUCCESS,
  GET_AFFILIATE_EARNINGS_FAIL,
} from '../constants/userConstants';
import {
  clearStoredAuthSessions,
  getStoredAuthSessions,
  invalidateServerSessions,
  suppressToastsAfterLogout,
} from '../utils/authLogout.js';

const baseUrl = process.env.REACT_APP_API_URL;

// Add these functions to your userActions.js file

// Generate QR Code Action

// Get regular users (from User model)
export const getRegularUsers = (search = '', filters = {}) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_USERS_REQUEST,
    })

    const {
      adminLogin: { userInfo }, // Changed from userLogin to adminLogin
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const params = new URLSearchParams()
    if (search) params.set('search', search)
    if (filters.venueId) params.set('venueId', filters.venueId)
    if (filters.clubId) params.set('clubId', filters.clubId)
    if (filters.fromDate) params.set('fromDate', filters.fromDate)
    if (filters.toDate) params.set('toDate', filters.toDate)
    const query = params.toString()
    const url = `${baseUrl}/users/regular-users${query ? `?${query}` : ''}`
    const { data } = await axios.get(url, config)

    dispatch({
      type: GET_USERS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_USERS_FAIL,
      payload: error.response?.data?.message || error.message,
    })
  }
}











export const generateQRCode = () => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`${baseUrl}/users/generate-qr`, config)
    return data
  } catch (error) {
    throw error.response?.data?.message || error.message
  }
}

// Scan QR Code Action
export const scanQRCode = (qrData, scanMethod = 'CAMERA', clubId = null) => async () => {
  try {
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }

    const { data } = await axios.post(
      `${baseUrl}/users/scan-qr`,
      { qrData, scanMethod, clubId },
      config
    )
    return data
  } catch (error) {
    throw error.response?.data?.message || error.message
  }
}

export const checkUser = (phoneNumber) => async (dispatch) => {
  try {
    dispatch({ type: CHECK_USER_REQUEST })

    const config = {
      headers: { 'Content-Type': 'application/json' }
    }

    const { data } = await axios.post(
      `${baseUrl}/users/check-user`,
      { phoneNumber },
      config
    )

    dispatch({ type: CHECK_USER_SUCCESS, payload: data })
    return data
  } catch (error) {
    dispatch({
      type: CHECK_USER_FAIL,
      payload: error.response?.data?.message || error.message
    })
    throw error
  }
}

export const login = (email, password) => async (dispatch) => {
  try {
    dispatch({
      type: USER_LOGIN_REQUEST,
    })

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    const { data } = await axios.post(
      `${baseUrl}/users/login`,
      { email, password },
      config
    )

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data,
    })

    localStorage.setItem('userInfo', JSON.stringify(data))
  } catch (error) {
    console.error('Login Error Details:', {
        message: error.message,
        response: error.response,
        request: error.request,
        config: error.config,
        baseUrl
    });
    dispatch({
      type: USER_LOGIN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

// Must match LOGIN_ACCESS_REVOKED_MESSAGE in backend/middleware/authmiddleware.js
export const LOGIN_ACCESS_REVOKED_MESSAGE =
  'Login access has been removed for your role - Please contact your admin'

// Signs the user out on every screen once the server says the role lost login access
export const setupLoginAccessInterceptor = (dispatch) =>
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (
        error.response?.status === 401 &&
        error.response?.data?.message === LOGIN_ACCESS_REVOKED_MESSAGE
      ) {
        await dispatch(logout())
        window.location.replace('/login')
      }
      return Promise.reject(error)
    },
  )

export const logout = () => async (dispatch) => {
  const sessions = getStoredAuthSessions()

  dispatch({
    type: USER_LOGOUT_REQUEST,
  })

  suppressToastsAfterLogout()
  clearStoredAuthSessions()
  dispatch({
    type: USER_LOGOUT,
  })

  try {
    await invalidateServerSessions(baseUrl, sessions)

    dispatch({
      type: USER_LOGOUT_SUCCESS,
      payload: { ok: true },
    })
  } catch (error) {
    dispatch({
      type: USER_LOGOUT_FAIL,
      payload: error.response?.data?.message || error.message,
    })
  }
}

export const getRole = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_ROLE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`${baseUrl}/roles/${userInfo.role._id}`, config)

    // Guard against malformed/unexpected responses (e.g. an API middleware
    // short-circuiting with `[]`) so a bad response can't wipe out the
    // logged-in user's real role/permissions.
    const isValidRole = data && typeof data === 'object' && !Array.isArray(data) && data._id

    if (!isValidRole) {
      dispatch({
        type: GET_ROLE_FAIL,
        payload: 'Received an invalid role response; keeping existing role',
      })
      return
    }

    dispatch({
      type: GET_ROLE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    // if (error.response.status === 401) {
    //   dispatch(logout())
    //   return
    // }
    dispatch({
      type: GET_ROLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getUsers = (search = '') => async (dispatch, getState) => {

  try {
    dispatch({
      type: GET_USERS_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    // Add search parameter to the URL if provided
    const url = search ? `${baseUrl}/users?search=${encodeURIComponent(search)}` : `${baseUrl}/users`
    const { data } = await axios.get(url, config)

    dispatch({
      type: GET_USERS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    //   if (error.response.status === 401) {
    //     dispatch(logout())
    //     return
    //   }
    dispatch({
      type: GET_USERS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const sendOTP = (phoneNumber, isLogin = true) => async (dispatch) => {
  try {
    dispatch({ type: SEND_OTP_REQUEST })

    const endpoint = isLogin ? 'send-login-otp' : 'send-registration-otp'
    const { data } = await axios.post(`${baseUrl}/users/${endpoint}`, { phoneNumber })

    const deliveryFailed =
      data?.otpMode !== 'static' &&
      data?.deliveryStatus &&
      data.deliveryStatus !== 'sent' &&
      data.deliveryStatus !== 'test_bypass'

    if (deliveryFailed) {
      const message = data?.deliveryResult?.error || data?.message || 'OTP delivery failed. Please try again.'
      dispatch({
        type: SEND_OTP_FAIL,
        payload: message
      })
      throw new Error(message)
    }

    dispatch({ type: SEND_OTP_SUCCESS, payload: data })
    return data
  } catch (error) {
    const message = error.response?.data?.message || error.message
    dispatch({
      type: SEND_OTP_FAIL,
      payload: message
    })
    throw new Error(message)
  }
}

export const verifyOTP = (phoneNumber, otp, isLogin = true, userData = {}) => async (dispatch) => {
  try {
    dispatch({ type: VERIFY_OTP_REQUEST })

    const endpoint = isLogin ? 'verify-login-otp' : 'verify-registration-otp'
    const payload = isLogin
      ? { phoneNumber, otp }
      : { phoneNumber, otp, ...userData }

    const { data } = await axios.post(`${baseUrl}/users/${endpoint}`, payload)

    dispatch({ type: VERIFY_OTP_SUCCESS, payload: data })
    return data
  } catch (error) {
    const message = error.response?.data?.message || error.message
    dispatch({
      type: VERIFY_OTP_FAIL,
      payload: message
    })
    throw new Error(message)
  }
}

export const addUser =
  (name, identifier, email, role, customers, ipAddress) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: ADD_USER_REQUEST,
        })

        const {
          userLogin: { userInfo },
        } = getState()

        const config = {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userInfo.token}`,
          },
        }

        const { data } = await axios.post(
          `${baseUrl}/users`,
          { name, identifier, email, role, customers, ipAddress },
          config
        )

        dispatch({
          type: ADD_USER_SUCCESS,
          payload: data,
        })
      } catch (error) {
        dispatch({
          type: ADD_USER_FAIL,
          payload:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        })
      }
    }

export const getUserByID = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_USER_BY_ID_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`${baseUrl}/users/${id}`, config)

    dispatch({
      type: GET_USER_BY_ID_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_USER_BY_ID_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const addCustomer = (id, customer) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ADD_CUSTOMER_TO_USER_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.post(
      `${baseUrl}/users/${id}/customers`,
      { customer },
      config
    )

    dispatch({
      type: ADD_CUSTOMER_TO_USER_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: ADD_CUSTOMER_TO_USER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const updateUser = (id, name, role, calling, email, ipAddress, distanceForCalling, assignedClubs) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: UPDATE_USER_REQUEST,
      })

      const {
        userLogin: { userInfo },
      } = getState()

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      }

      const body = { name, role, calling, email, ipAddress, distanceForCalling }
      if (assignedClubs !== undefined) {
        body.assignedClubs = assignedClubs
      }

      const { data } = await axios.put(
        `${baseUrl}/users/${id}`,
        body,
        config
      )

      dispatch({
        type: UPDATE_USER_SUCCESS,
        payload: data,
      })
    } catch (error) {
      dispatch({
        type: UPDATE_USER_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      })
    }
  }

export const resetDeviceID = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: RESET_DEVICE_ID_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(
      `${baseUrl}/users/reset-device-id/${id}`,
      {},
      config
    )

    dispatch({
      type: RESET_DEVICE_ID_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: RESET_DEVICE_ID_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const resetPassword = (id, password = null) => async (dispatch, getState) => {
  try {
    dispatch({
      type: RESET_PASSWORD_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const body = password ? { password } : {}

    const { data } = await axios.put(
      `${baseUrl}/users/reset-password/${id}`,
      body,
      config
    )

    dispatch({
      type: RESET_PASSWORD_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: RESET_PASSWORD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const removeCustomer = (id, customer) => async (dispatch, getState) => {
  try {
    dispatch({
      type: REMOVE_CUSTOMER_FROM_USER_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.delete(
      `${baseUrl}/users/${id}/customers/${customer}`,
      config
    )

    dispatch({
      type: REMOVE_CUSTOMER_FROM_USER_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: REMOVE_CUSTOMER_FROM_USER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const fetchAttendance = (id, date) => async (dispatch, getState) => {
  try {
    dispatch({
      type: FETCH_ATTENDANCE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(
      `${baseUrl}/users/fetch-attendance/${id}/${date}`,
      config
    )

    dispatch({
      type: FETCH_ATTENDANCE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: FETCH_ATTENDANCE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const resignUser = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: RESIGN_USER_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(`${baseUrl}/users/resign/${id}`, {}, config)

    dispatch({
      type: RESIGN_USER_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: RESIGN_USER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const forceLogoutUser = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: FORCE_LOGOUT_USER_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(`${baseUrl}/users/force-logout/${id}`, {}, config)

    dispatch({
      type: FORCE_LOGOUT_USER_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: FORCE_LOGOUT_USER_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const forceLogoutMultipleUsers = (userIds) => async (dispatch, getState) => {
  try {
    dispatch({
      type: FORCE_LOGOUT_MULTIPLE_REQUEST,
    })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.put(`${baseUrl}/users/force-logout-multiple`, { userIds }, config)

    dispatch({
      type: FORCE_LOGOUT_MULTIPLE_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: FORCE_LOGOUT_MULTIPLE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const getAffiliateStats = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_AFFILIATE_STATS_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    const { data } = await axios.get(`${baseUrl}/users/affiliate/stats`, config)

    dispatch({
      type: GET_AFFILIATE_STATS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_AFFILIATE_STATS_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    })
  }
}

export const getAffiliateReferrals = (page = 1, limit = 20, search = '') => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_AFFILIATE_REFERRALS_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    let url = `${baseUrl}/users/affiliate/referrals?page=${page}&limit=${limit}`
    if (search) {
      url += `&search=${search}`
    }

    const { data } = await axios.get(url, config)

    dispatch({
      type: GET_AFFILIATE_REFERRALS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_AFFILIATE_REFERRALS_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    })
  }
}

export const getAffiliateEarnings = (page = 1, limit = 20, startDate, endDate) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_AFFILIATE_EARNINGS_REQUEST })

    const {
      userLogin: { userInfo },
    } = getState()

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    }

    let url = `${baseUrl}/users/affiliate/earnings?page=${page}&limit=${limit}`
    if (startDate && endDate) {
      url += `&startDate=${startDate}&endDate=${endDate}`
    }

    const { data } = await axios.get(url, config)

    dispatch({
      type: GET_AFFILIATE_EARNINGS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: GET_AFFILIATE_EARNINGS_FAIL,
      payload: error.response && error.response.data.message
        ? error.response.data.message
        : error.message,
    })
  }
}
